    function addToCartWithLoader(variantId) {
        let btn = event.currentTarget;
        btn.classList.add("loading");
        document.querySelector('.atdtocaet' + variantId).click();
        setTimeout(() => {
            btn.classList.remove("loading");
        }, 1000);
    } 